import FILES from '../actionTypes';

import { AppAction } from '../../../types/app';
import { FilesState } from '../types';

const initialState: FilesState = {
  readyStatus: FILES.LOAD.INVALID,
  err: null,
  count: 0,
  rows: [],
};

export default (
  state: FilesState = initialState,
  action: AppAction = {}
): FilesState => {
  switch (action.type) {
    case FILES.LOAD.REQUESTING:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
      };
    case FILES.LOAD.FAILURE:
      return {
        ...state,
        err: action.err,
        readyStatus: action.type,
      };
    case FILES.LOAD.SUCCESS:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
        count: action.count,
        rows: action.rows,
      };
    default:
      return state;
  }
};
